/**
 * Focus Visible Hook
 * 
 * Ensures focus ring is visible only on keyboard navigation
 * (not on mouse clicks) - Safari-compatible
 */

import { useEffect, useState } from 'react'

export function useFocusVisible() {
  const [isKeyboard, setIsKeyboard] = useState(false)

  useEffect(() => {
    const handleMouseDown = () => {
      setIsKeyboard(false)
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab' || (typeof e.key === 'string' && e.key.startsWith('Arrow'))) {
        setIsKeyboard(true)
      }
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return {
    'data-focus-visible': isKeyboard || undefined,
    className: isKeyboard ? 'focus-visible' : '',
  }
}

